import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  ICPLAuthPermissionsClient,
  PermissionManagementMatrixModel,
  PermissionCategoryModel,
  PermissionModel,
  UserPermissionModel,
} from "./api/cplauthapi/CPLAuthAPI";

export interface IPermissionsService {
  getAllPermissionCategories(): Promise<PermissionCategoryModel[]>;
  grantUserPermissionAssignment(userID: string, permissionID: number): Promise<void>;
  denyUserPermissionAssignment(userID: string, permissionID: number): Promise<void>;
  grantUserGroupPermissionAssignment(userGroupID: number, permissionID: number): Promise<void>;
  denyUserGroupPermissionAssignment(userGroupID: number, permissionID: number): Promise<void>;
  deletePermissionAssignment(permissionAssignmentID: number): Promise<void>;
  getAllPermissionsForCategory(permissionCategoryID: number): Promise<PermissionModel[]>;
  getPermissionAssignmentsMatrix(permissionID: number): Promise<PermissionManagementMatrixModel>;
  getAllPermissionsForUser(userID: string): Promise<UserPermissionModel[]>;
}

@injectable()
export class PermissionsService implements IPermissionsService {
  @inject(SERVICE_TYPES.CPLAuthPermissionsClient) cplPermissionsClient!: ICPLAuthPermissionsClient;

  grantUserPermissionAssignment(userID: string, permissionID: number): Promise<void> {
    return this.cplPermissionsClient.grantUserPermissionAssignment(userID, permissionID);
  }
  denyUserPermissionAssignment(userID: string, permissionID: number): Promise<void> {
    return this.cplPermissionsClient.denyUserPermissionAssignment(userID, permissionID);
  }
  grantUserGroupPermissionAssignment(userGroupID: number, permissionID: number): Promise<void> {
    return this.cplPermissionsClient.grantUserGroupPermissionAssignment(userGroupID, permissionID);
  }
  denyUserGroupPermissionAssignment(userGroupID: number, permissionID: number): Promise<void> {
    return this.cplPermissionsClient.denyUserGroupPermissionAssignment(userGroupID, permissionID);
  }
  deletePermissionAssignment(permissionAssignmentID: number): Promise<void> {
    return this.cplPermissionsClient.deletePermissionAssignment(permissionAssignmentID);
  }
  getAllPermissionsForCategory(permissionCategoryID: number): Promise<PermissionModel[]> {
    return this.cplPermissionsClient.getAllPermissionsForCategory(permissionCategoryID);
  }
  getPermissionAssignmentsMatrix(permissionID: number): Promise<PermissionManagementMatrixModel> {
    return this.cplPermissionsClient.getPermissionAssignmentsMatrix(permissionID);
  }
  getAllPermissionCategories(): Promise<PermissionCategoryModel[]> {
    return this.cplPermissionsClient.getAllPermissionCategories();
  }
  getAllPermissionsForUser(userID: string): Promise<UserPermissionModel[]> {
    return this.cplPermissionsClient.getAllPermissionsForUser(userID);
  }
}
